import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Intro.module.scss";
import StatesContext from "../../context/states";
import PathContext from "../../context/path";
import Btn from '../../components/Btn';
const Intro = () => {
  const path = useContext(PathContext);
  const states = useContext(StatesContext);
  const { updateRouter, hideMain } = states;
  const refWrap = useRef(null);


  useEffect(()=>{
    document.querySelector('body').style.opacity = 1;
  },[]);
  useEffect(() => {
    const wrap = refWrap.current;
    if (!hideMain) {
      wrap.classList.remove(styles.hide);
    } else {
      wrap.classList.add(styles.hide);
    }
  }, [hideMain]);


  return (
    <>
      <div className={`${styles.wrap} ${styles.hide}`} ref={refWrap}>
        <div className={styles.info}>
          <div className={styles.info__inner}>
          <h1 className={styles.title}>Твой выбор</h1>
          <div className={styles.text}>Ежедневно мы делаем множество выборов. Но некоторые решения определяют наше будущее — например, такие как выбор работодателя, команды, развития карьеры. Выбирайте, что важно в работе именно для вас, вместе с Газпромбанком!</div>
          </div>
          <div className={styles.btn} onClick={()=>updateRouter('main')}>

            <Btn text={'Начать'} size={'big'} />
          </div>
        </div>
        <div className={styles.img} style={{ 'maskImage': `url(${path}/img/mask-intro.svg)`, 'WebkitMaskImage': `url(${path}/img/mask-intro.svg)` }}>
          <div className={styles.img__flash}></div>
        </div>
        <div className={styles.bg}>
          <picture>
            <source media="(max-width: 1024px)" srcSet={`${path}/img/intro-bg-mobile.webp`} />
            <img src={`${path}/img/intro-bg.webp`} alt="" />
          </picture>
        </div>
      </div >
    </>
  );

}

export default Intro;
